import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import usuarioConfiguracionService from '../../../service/seguridad/usuarioConfiguracionService';
import empleadoService from '../../../service/administracion/empleadoService';
import usuarioService from '../../../service/seguridad/usuarioService';
import almacenService from '../../../service/administracion/almacenService';

import Header from './Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';


import {
    BOLETA_DE_VENTA,
    FACTURA,
    NOTA_VENTA,
    NOTA_DE_CREDITO
} from "../../../common/types/tipoComprobanteType";

export default class Index extends PaginationBase {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            loadingEdit: false,
            loadingSource: true,
            estados: estadoMock.values,
            configuraciones: [],
            empleados: [],
            almacenVentas: [],
            almacenLogisticas: [],
            serieCobranza: [],
            filter: {
                nombre: '',
                estado: 0,
                idUsuario: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idConfiguracion: 0,
            idUsuario: 0,
            valor: false,
            configuraciones: [],
            empleados: [],
            selectedRowKeys: [],
            listaDetalle: [],

            almacenVentas: [],
            almacenLogisticas: [],
            serieCobranza: [],

            idAlmacenVentas: [],
            idAlmacenLogisticas: [],
            idSerieCobranza: [],
        };
    };

    handleClearFilters = () => {
        var filter = {
            nombre: '',
            estado: 0,
            idUsuario: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await usuarioConfiguracionService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Usuario Configuracion.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await usuarioConfiguracionService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de UsuarioCon figuracion.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await usuarioConfiguracionService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await usuarioConfiguracionService.eliminar(values);
            else
                response = await usuarioConfiguracionService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    /******************** FORM MODAL *****************/


    handleSelect = (selected, rows) => {

        if (this.state.formValues.idUsuario == 0) {
            dialog.error('Seleccione usuario');
            return false;

        }
        debugger
        var listaDetalle = [];
        rows.forEach(row => {
            var item = {
                IdConfiguracion: row.id,
                IdUsuario: this.state.formValues.idUsuario,
            };
            listaDetalle.push(item)

        });


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaDetalle: listaDetalle,
                selectedRowKeys: selected
            },

        });


    };

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.configuraciones = this.state.configuraciones;
        formValues.empleados = this.state.empleados;
        formValues.almacenLogisticas = this.state.almacenLogisticas;
        formValues.almacenVentas = this.state.almacenVentas;
        formValues.serieCobranza = this.state.serieCobranza;

        this.setState({ visible: true, formValues });
    };




    handleEdit = async () => {
        this.setState({ loadingEdit: true })
        var formValues = this.fetchEmptyFormValues();
        formValues.configuraciones = this.state.configuraciones;
        formValues.empleados = this.state.empleados;
        formValues.almacenLogisticas = this.state.almacenLogisticas;
        formValues.almacenVentas = this.state.almacenVentas;
        formValues.serieCobranza = this.state.serieCobranza;
        formValues.id = 1;

        this.setState({ visible: true, formValues, loadingEdit: false });

    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response = await usuarioConfiguracionService.registrar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleChangeForm = async (value, form) => {

        debugger
        if (this.state.formValues.id > 0) {

            var permisoSerie = [];
            var permisoAlmacenLo = [];
            var permisoAlmacenVe = [];

            const permisos = await usuarioService.listarPermisosPorIdUsuario(value.key);

            permisos.forEach((item, i) => {
                if (item.idTipoPermiso == 1) {
                    permisoSerie.push(item.serie);
                    return;
                }
                if (item.idTipoPermiso == 2) {
                    permisoAlmacenLo.push(item.idAlmacen);
                    return;
                }

                if (item.idTipoPermiso == 3) {
                    permisoAlmacenVe.push(item.idAlmacen);
                    return;
                }
            });

            var listaDetalle = [];
            var selected = [];

            const configuraciones = await usuarioConfiguracionService.obtenerPorId(value.key);

            configuraciones.forEach(row => {
                var item = {
                    IdConfiguracion: row.idConfiguracion,
                    IdUsuario: value.key,
                };
                listaDetalle.push(item);
                selected.push(row.idConfiguracion)

            });

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idUsuario: value.key,
                    listaDetalle: listaDetalle,
                    selectedRowKeys: selected,
                    idAlmacenVentas: permisos.length > 0 ? permisoAlmacenVe : [],
                    idAlmacenLogisticas: permisos.length > 0 ? permisoAlmacenLo : [],
                    idSerieCobranza: permisos.length > 0 ? permisoSerie : [],
                }
            });
        } else {

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idUsuario: value.key
                }
            });
        }


    };
    async componentDidMount() {
        this._isMounted = true;

        this._initPagination(this.state.filter, usuarioConfiguracionService.paginacion);
        var tipoComprobante = [BOLETA_DE_VENTA.ID, FACTURA.ID, NOTA_VENTA.ID];


        const configuraciones = await usuarioConfiguracionService.listar();
        const empleados = await empleadoService.listarEmpleadoSistema();
        const almacenes = await almacenService.listar();
        const series = await usuarioConfiguracionService.listarSeries({ idTipoComprobante: tipoComprobante.toString() });
        var almacene_v = almacenes.filter((m) => m.idTipoAlmacen == 1); // ventas
console.log(empleados)
        if (this._isMounted) {
            this.setState({
                loadingSource: false,
                configuraciones: configuraciones ? configuraciones : [],
                empleados: empleados ? empleados : [],
                almacenVentas: almacene_v ? almacene_v : [],
                almacenLogisticas: almacenes ? almacenes : [],
                serieCobranza: series ? series : [],

            });
        }

    }
    componentWillUnmount() {
        this._isMounted = false;
      }

    render() {
        return (
            <div>
                <Header
                    title="Configuración Usuario"
                    loadingEdit={this.state.loadingEdit || this.state.loadingSource}
                    onEdit={this.handleEdit}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    empleados={this.state.empleados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeRow={this.handleSelect}
                    onChangeForm={this.handleChangeForm}

                />
            </div>
        );
    };
}